export const shareCardTitle =
  'Invite students and employees from different institute/organization to learn on Dphi';

// share urls
export const USER_DASHBOARD_LINKEDIN_URL = `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.origin}?utm_source=user_dashboard&utm_medium=linkedin&utm_campaign=rp`;
export const USER_DASHBOARD_FACEBOOK_URL = `https://www.facebook.com/sharer/sharer.php?u=${window.location.origin}?utm_source=user_dashboard&utm_medium=facebook&utm_campaign=rp`;

// urls
export const RECOMMENDATION_URL = '/api/dashboard/recommendation/';
export const USER_DASHBOARD_COURSES_URL =
  '/api/courses/?page_size=100&my=1 ';
export const GET_USER = '/api/user-profile/';

// images
export const DASHBOARD_EMPTY_COURSES =
  '/static/images/courses/courses.png';
export const DASHBOARD_EMPTY_CHALLENGES =
  '/static/images/practice/datathon.png';
export const DASHBOARD_WELCOME_CONTAINER_IMAGE =
  '/static/images/dashboard_welcome.png';

export const DISCORD_USERS_STACK_IMAGE =
  '/static/images/dashboard/discord-users-stack.svg';
